import * as React from 'react';
import PropTypes from 'prop-types';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

const GoSelect = ({ title, name, value, items, displayKey, itemValue, handleChange, size = "medium" }) => {
    return (
        <FormControl sx={{ m: 1, minWidth: 180 }} size={size}>
            <InputLabel id={`${name}-label`}>{title}</InputLabel>
            <Select
                labelId={`${name}-label`}
                id={name}
                value={value}
                name={name}
                label={title}
                onChange={handleChange}
            >
                {items.map((item, index) => (
                    <MenuItem key={index} value={itemValue === "fullItem" ? item : item[itemValue]}>{item[displayKey]}</MenuItem>
                ))}
            </Select>
        </FormControl >
    );
};

GoSelect.propTypes = {
    title: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired,
    items: PropTypes.array.isRequired,
    displayKey: PropTypes.string.isRequired,
    itemValue: PropTypes.string.isRequired,
    handleChange: PropTypes.func.isRequired,
};

export default GoSelect;